<template>
  <div class="page_content learner_dashboard subscription_plan my_purchases" aria-label="My Purchases Page">

    <div class="row page-heading">
      <div class="col-10 input module_heading">
        <div class="module_icon ic22-buy"></div>
        <div class="head_txt module_type_name ace_sec_hd" role="heading" aria-label="My Purchases">
          My Purchases
        </div>
      </div>

      <div class="col-2 btn-container pull-right">
        <a v-if="institution.refundPolicyLink" target="_blank" :href="institution.refundPolicyLink" >refund policy </a>
      </div>
    </div>

		<div class="row page_content_container">
			<div class="col-12">

        <template v-if="!showErrorState">
          <template v-if="showLoader">
            <p class="text-center">Loading..</p>
          </template>

          <template v-if="!showLoader">

            <template v-if="userTransactionsToShow.length === 0">
              <div class="no_info text-center mt-5">No purchases yet.</div>
            </template>

            <template v-if="userTransactionsToShow.length > 0">
              <div class="row">

                <div class="col-2"></div>

                <div class="col-8">

                  <div class="row crd_container d-flex justify-content-center">
                    <div class="col-4" v-for="(transaction, index) in userTransactionsToShow">

                      <b-card class="crd">

                        <div class="row fld_row">
                          <div class="col-12 fld_val" v-if="transaction.programGuide">
                            {{transaction.programGuide.title}}
                          </div>
                        </div>

                        <div class="row fld_row">
                          <div class="col-12 fld_label">
                            Plan
                          </div>
                          <div class="col-12 fld_val">
                            {{transaction.pricingPlanLearner.name}}
                          </div>
                        </div>

                        <div class="row fld_row">
                          <div class="col-12 fld_label">
                            Plan Price
                          </div>
                          <div class="col-12 fld_val">
                            ${{transaction.price.toFixed(2)}}
                            <span v-if="transaction.pricingPlanLearner.type === 'subscription-monthly'">/month</span>
                            <span v-if="transaction.pricingPlanLearner.type === 'subscription-monthly-payment-plan'">/month</span>
                            <span v-if="transaction.pricingPlanLearner.type === 'subscription-yearly'">/year</span>
                          </div>
                        </div>

                        <div class="row fld_row">
                          <div class="col-12 fld_label">
                            Current Plan Period
                          </div>
                          <div class="col-12 fld_val">
                            {{getDateString(transaction.startDate)}} - {{getDateString(transaction.endDate)}}
                          </div>
                        </div>

                        <div class="row fld_row" v-if="(transaction.pricingPlanLearner.type === 'subscription-monthly' || transaction.pricingPlanLearner.type === 'subscription-yearly') && transaction.status !== 'CANCELED' && transaction.status !== 'REFUNDED'">
                          <div class="col-12 fld_label">
                            Next Payment Date
                          </div>
                          <div class="col-12 fld_val">
                            {{getDateString(transaction.endDate)}}
                          </div>
                        </div>
                       <div class="row fld_row" v-if="(transaction.pricingPlanLearner.type === 'subscription-monthly-payment-plan') && transaction.status !== 'CANCELED' && transaction.status !== 'REFUNDED'">
                          <div class="col-12 fld_label">
                            Next Payment Date 
                          </div>
                          <div class="col-12 fld_val">
                            {{getDateString(transaction.endDate)}}
                          </div>
                        </div>
                        <div class="row fld_row" v-if="transaction.pricingPlanLearner.type === 'subscription-monthly' || transaction.pricingPlanLearner.type === 'subscription-yearly'">
                          <div class="col-12 fld_val" v-if="transaction.status !== 'CANCELED'  && transaction.status !== 'REFUNDED'">
                            <a href="javascript:void(0)" @click="showCancelSubscriptionModal(index)">
                              Cancel Subscription
                            </a>
                          </div>
                          <div class="col-12 fld_val" v-else-if="transaction.status === 'CANCELED'">
                              Canceled Subscription
                          </div>

                        </div>
                        <div class="row fld_row" v-if="transaction.pricingPlanLearner.type === 'subscription-monthly-payment-plan'">
                          <div class="col-12 fld_val" v-if="transaction.status !== 'CANCELED'  && transaction.status !== 'REFUNDED' && Date.now()>transaction.allowCancleAfter ">
                            <a href="javascript:void(0)" @click="showCancelSubscriptionModal(index)">
                              Cancel Subscription
                            </a>
                          </div>
                          <div class="col-12 fld_label" v-if="Date.now()<transaction.allowCancleAfter">
                            Cancel Subscription Allowed After
                          </div>
                          <div class="col-12 fld_val" v-if="Date.now()<transaction.allowCancleAfter">
                            {{getDateString(transaction.allowCancleAfter)}}
                          </div>

                          <div class="col-12 fld_val" v-else-if="transaction.status === 'CANCELED'">
                              Canceled Subscription
                          </div>

                        </div>

                        <div class="row fld_row" v-if="transaction.receiptUrl">
                          <div class="col-12 fld_label">
                            Receipt
                          </div>
                          <div class="col-12 fld_val">
                            <a :href="transaction.receiptUrl" target="_blank">View</a>
                          </div>
                        </div>
                        <div class="row fld_row" v-if="transaction.status === 'REFUNDED'">
                          <div class="col-12 fld_label">
                            REFUNDED
                          </div>
                        </div>

                    </b-card>

                    <!-- Cancel subscription confirm modal -->
                    <div class="modal__v24">
                      <b-modal v-model="isCancelSubscriptionModalVisible[index]" title="Please Confirm!" :header-bg-variant="'discover-content-delete-modal'" hide-header-close no-close-on-backdrop no-close-on-esc centered>
                        <div class="text-center msg_section_inner">
                          <h6>Are you sure you want to cancel subscription for <br/>
                            <strong v-if="transaction.programGuide" >"{{transaction.programGuide.title}}"</strong>?
                          </h6>
                        </div>
                        <div slot="modal-footer" class="w-100">
                          <b-button @click="processDeleteSubscription(transaction, index)" class="btn button-primary float-right mr-2"> yes </b-button>
                          <b-button @click="closeCancelSubscriptionModal(index)" class="btn button-primary float-right mr-2"> cancel </b-button>
                        </div>
                      </b-modal>
                    </div>

                  </div>
                </div>

                </div>
              </div>


            </template>
          </template>
        </template>

        <template v-if="showErrorState">
          <p class="mt-4 text-center">Oops! Something went wrong. Please refresh this page and try again</p>
        </template>

			</div>
		</div>



	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { StorageFactory } from '../../../storageFactory'

export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'purchases',
  props: [],
  components: {
  },
  data: () => {
    return {
      userTransactions: [],
      showErrorState: false,
      showLoader: false,
      isCancelSubscriptionModalVisible: {}
    }
  },

  mounted () {
    this.loadPurchases()
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'loadUserTransactions',
      'loadDeleteSubscription'
    ]),

    async loadPurchases () {
      this.showLoader = true
      // log login activity
      this.loadLogDashboardActivity({action: 'purchases', page: 'purchases', link: ''})

      this.userTransactions = await this.loadUserTransactions()

      this.showLoader = false
    },
    getDateString (timestamp) {
      let date = new Date(timestamp)
      return date.toLocaleDateString()
    },
    async processDeleteSubscription (transaction, index) {
      let transactionObj = {
        uuid: transaction.uuid,
        subscriptionId: transaction.subscriptionId
      }
      this.showLoader = true
      await this.loadDeleteSubscription(transactionObj)
      this.userTransactions = await this.loadUserTransactions()

      this.showLoader = false
      this.closeCancelSubscriptionModal (index)
    },
    showCancelSubscriptionModal (index) {
      this.$set(this.isCancelSubscriptionModalVisible, index, true);
    },
    closeCancelSubscriptionModal (index) {
      this.$set(this.isCancelSubscriptionModalVisible, index, false);
    },
  },

  computed: {
    ...mapState({
      'institution': state => state.institution.institution
    }),
    userTransactionsToShow () {
      let userTransactionsToShow = []
      if (this.userTransactions && this.userTransactions.length > 0) {
        this.userTransactions.forEach((item, i) => {
          if ((item.status === 'COMPLETED' || item.status === 'SUBSCRIPTION_ISSUE' || item.status === 'CANCELED' || item.status === 'REFUNDED' ) && item.stripeSubscription) {
            item.subscriptionObj = JSON.parse(item.stripeSubscription)
            userTransactionsToShow.push(item)
          } else {
            userTransactionsToShow.push(item)
          }
        })
      }
      return userTransactionsToShow
    },
    userCanceledTransactionsToShow () {
      let userTransactionsToShow = []
      if (this.userTransactions && this.userTransactions.length > 0) {
        this.userTransactions.forEach((item, i) => {
          if (item.status === 'CANCELED' || item.status === 'REFUNDED' ) {
            item.subscriptionObj = JSON.parse(item.stripeSubscription)
            userTransactionsToShow.push(item)
          } else {
            userTransactionsToShow.push(item)
          }
        })
      }
      return userTransactionsToShow
    }
  },

  watch: {
  }
}
</script>

<style>
.green {
  text-color: green;
}
</style>



// WEBPACK FOOTER //
// src/app/user/components/Purchases.vue